import React from 'react';
import { inject, observer } from 'mobx-react';
import './index.scss'

//api
import {api} from '../../../../functions/api'

//material-ui
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import CircularProgress from "@material-ui/core/CircularProgress";
import Chip from '@material-ui/core/Chip';
import Input from '@material-ui/core/Input';
import Paper from '@material-ui/core/Paper'


//custom components
import CustomAvatar from '../../../../components/basic/customAvatar';
import CustomSnackbar from '../../../../components/global/snackbar';
import ChooseCategory from './addCategory';
import SelectSearch from '../../../../components/basic/SelectSearch/SelectSearch';
import CustomInput from '../../../../components/basic/input';

//other libraries
import {toJS} from 'mobx';
import moment from 'moment';
import Icon from '@mdi/react'
import { mdiMenuDown} from '@mdi/js'

const TIMEOUT = 3000;
const TIMEOUT_FOR_API_CALL = 1000
@inject('internal')
@inject('translate')
@observer
export default class ProductBasicInfo extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            category: this.props.internal.dataForSimpeTable.category_id,
            tag: 10,
            production: this.props.internal.dataForSimpeTable.production,
            shops_production: this.props.internal.dataForSimpeTable.shops_production,
            selectedTags: [],
            selectedTagsIds: [],
            selectedTagsNames: [],
            openCategoryDialog: false,
            relativeProducts: [], // suvisiace produkty
            alternativeProducts: [], // alternativne produkty,
            accessories: [], // prislusenstvo
            allProducts: [],
            allStaticSets: [],
            warehouse_status: this.props.internal.dataForSimpeTable.warehouse_status_id,
            allAlternativeProducts: [],
            clientList: [],
            invisibleForClients: []
        }
    }

    componentDidMount() {
        // this.setState({selectedTags: this.props.internal.dataForSimpeTable.tags})
        let tags = toJS(this.props.internal.dataForSimpeTable.tags);
        let selectedTags = []
        let selectedTagsIds = []
        let selectedTagsNames = []
        for(let i=0; i< tags.length; i++) {
            selectedTags.push(tags[i]);
            selectedTagsIds.push(tags[i].name);
            selectedTagsNames.push(tags[i].name);
        }
        this.setState({selectedTags: selectedTags, selectedTagsIds: selectedTagsIds, selectedTagsNames: selectedTagsNames}, () => {
        })


        Promise.all([
            this.loadTags(),
            this.loadCategories(),
            this.loadProductsAndStaticSets(),
            this.loadFromCategory(),
            this.loadInvisibleForClients()
        ]).then(() => {
            const alternativeProducts = this.props.internal.dataForSimpeTable.alternatives
              .map(i => ({
                  value: i.id,
                  label: i.name
              }))

            const relativeProducts = this.props.internal.dataForSimpeTable.relatives
              .filter(i => i.hasOwnProperty('code'))
              .map(i => ({
                  value: i.id,
                  label: i.name
              }))

            const relativeStaticSets = this.props.internal.dataForSimpeTable.relatives
              .filter(i => !i.hasOwnProperty('code'))
              .map(i => ({
                  value: i.id,
                  label: i.name
              }))

            const accessories = this.props.internal.dataForSimpeTable.accessories
              .map(i => ({
                  value: i.id,
                  label: i.name
              }))

            this.setState({ alternativeProducts, relativeProducts, relativeStaticSets, accessories, loading: false })
        })
    }

    loadFromCategory = async() => {

        let category_id = toJS(this.props.internal.dataForSimpeTable.category_id);

        let load_data = await api({
            method: 'POST',
            url: `products/category-products`,
            authorization: this.props.internal.user.access_token,
            params: {
                category_id: category_id
            }
        })

        if(load_data.success === true) {
            let all_alternative_products = load_data.data.data
            let alternativeProd = []
            for(let i in all_alternative_products) {
                alternativeProd.push({label: all_alternative_products[i].name, value: all_alternative_products[i].id})
            }
            this.setState({allAlternativeProducts: alternativeProd})
        }
    }

    timeout = null;
    componentWillUnmount() {
        clearTimeout(this.timeout)
    }

    turnOffSnackBar = () => {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
            this.setState({
                message: "",
                openSnackbar: false,
                snackBarError: false,
            })
        }, TIMEOUT)
    }

    loadProductsAndStaticSets = async() => {
        let idCurrentProduct = this.props.routerData.match.params.idProduct;
        let load_products = await api({
            url: 'products',
            method: 'get',
            authorization: this.props.internal.user.access_token,
            params: {
                page: {
                    size: 1
                }
            }
        })

        if(load_products.success) {
            const allProducts = load_products.data
              .lists
              .products
              .filter(i => Number(idCurrentProduct) !== i.id)
              .map(i => ({
                  value: i.id,
                  label: i.name,
              }))
            this.setState({ allProducts })
            const allStaticSets = load_products.data
              .lists
              .static_sets
              .filter(i => Number(idCurrentProduct) !== i.id)
              .map(i => ({
                  value: i.id,
                  label: i.name,
              }))
            this.setState({ allStaticSets })
        }
    }

    loadInvisibleForClients = async() => {
        let idCurrentProduct = this.props.routerData.match.params.idProduct;
        let response = await api({
            url: `products/${idCurrentProduct}/invisible-for-clients`,
            method: 'get',
            authorization: this.props.internal.user.access_token
        })

        if (response.success) {
            console.log(response.data)
            const invisibleForClients = [];
            const clientList = response.data.data.clients.map(client => {
                const clientItem = {
                    value: client.id,
                    label: client.name
                };

                if (true === client.invisible) {
                    invisibleForClients.push(clientItem);
                }

                return clientItem;
            });

            this.setState({ invisibleForClients, clientList });
        }
    }

    loadTags = async() => {
        this.setState({loading: true})
        let load_data = await api({
            method: 'get',
            url: 'lists/tags?page[size]=99999',
            authorization: this.props.internal.user.access_token,
        })

        if(load_data.success === true) {
            let tmpData = toJS(this.props.internal.dataForSimpeTable)
            tmpData['tags_all'] = load_data.data.data
            this.props.internal.setDataForSimpeTable(tmpData)
        }
    }

    categories = [];

    loadCategories = async () => {
        this.categories = [];
        this.setState({loading: true})
        let load_data = await api({
            method: 'get',
            url: 'lists/categories',
            authorization: this.props.internal.user.access_token,
        })
        if(load_data.success === true) {
            this.categories = load_data.data.data;
            this.convertTreeToList(load_data.data.data)
        }

    }

    convertTreeToList = (allData) => {
        for(let i=0; i<allData.length; i++) {
            this.oneCategory(allData[i])
        }
    }

    categories2 = []
    oneCategory = (oneItem) => {
        this.categories2.push(oneItem)
        if(oneItem.children) {
            for(let i=0; i<oneItem.children.length; i++) {
                this.oneCategory(oneItem.children[i])
            }
        }
    }



    handleChangeProduction = async(event) => {
        this.setState({production: event.target.value})
        let idProduct = toJS(this.props.routerData.match.params.idProduct)
        this.setState({loading: true})

        let update_data = await api({
            method: 'patch',
            url: `products/${idProduct}`,
            authorization: this.props.internal.user.access_token,
            params: {
                production: event.target.value
            }
        });

        if(update_data.success === true) {
            this.props.internal.setSnackbar(update_data.data.message, true)
            // this.loadBasicData()
            this.props.internal.setDataForSimpeTable(update_data.data.data)
            this.setState({loading: false})
        }
    }

    handleChangeShopsProduction = async(event) => {
        this.setState({shops_production: event.target.value})
        let idProduct = toJS(this.props.routerData.match.params.idProduct)
        this.setState({loading: true})
        let update_data = await api({
            method: 'patch',
            url: `products/${idProduct}`,
            authorization: this.props.internal.user.access_token,
            params: {
                shops_production: event.target.value
            }
        });

        if(update_data.success === true) {
            this.props.internal.setSnackbar(update_data.data.message, true)
            // this.loadBasicData()
            this.props.internal.setDataForSimpeTable(update_data.data.data)
            this.setState({loading: false})
        }
    }

    changeInvisibleForClients = (values) => {
        this.setState({invisibleForClients: values}, () => {
            let idProduct = toJS(this.props.routerData.match.params.idProduct)

            api({
                method: 'put',
                url: `products/${idProduct}/invisible-for-clients`,
                authorization: this.props.internal.user.access_token,
                params: {
                    clients: this.state.invisibleForClients.map(item => item.value)
                }
            }).then(response => {
                if (response.success) {
                    this.props.internal.setSnackbar(response.data.message, true);
                } else {
                    this.props.internal.setSnackbar(response.data.message, true, true);
                }
            });
        });
    }

    handleChangeCategoty = async(event) => {
        this.setState({category: event.target.value})

        let idProduct = toJS(this.props.routerData.match.params.idProduct)

        let update_data = await api({
            method: 'patch',
            url: `products/${idProduct}`,
            authorization: this.props.internal.user.access_token,
            params: {
                category_id: event.target.value
            }
        })

        if(update_data.success === true) {
            this.setState({message: update_data.data.message, openSnackbar: true})
        }
        this.turnOffSnackBar();
    }

    handleChangeCategory2 = async(idCategory) => {
        this.setState({category: idCategory})

        let idProduct = toJS(this.props.routerData.match.params.idProduct)

        let update_data = await api({
            method: 'patch',
            url: `products/${idProduct}`,
            authorization: this.props.internal.user.access_token,
            params: {
                category_id: Number(idCategory)
            }
        })

        if(update_data.success === true) {
            this.setState({message: update_data.data.message, openSnackbar: true, openCategoryDialog: false})
            this.loadBasicData()
        }
        this.turnOffSnackBar();
    }

    loadBasicData = async(loading = true) => {
        this.setState({loading})
        let load_data = await api({
            method: 'get',
            url: 'products/' + this.props.routerData.match.params.idProduct,
            authorization: this.props.internal.user.access_token,
        })

        if (load_data.success && load_data.success === true) {
            this.props.internal.setDataForSimpeTable(load_data.data.data)

        }

        this.setState({loading: false})
    }

    categories = [
        {
            value: "available",
            label: this.props.translate.i18n.MODULES.PRODUCTS.AVAILABLE
        },
        {
            value: "on_route",
            label: this.props.translate.i18n.MODULES.PRODUCTS.ON_ROUTE
        },
        {
            value: "to_order",
            label: this.props.translate.i18n.MODULES.PRODUCTS.TO_ORDER
        }
    ]

    formatData = (data) => {
        return moment(data).format("DD.MM.YYYY HH:mm")
        // return dateformat(data, "dd.mm.yyyy HH:MM")
    }


    handleChangePhoto = async (data) => {

        let idProduct = this.props.routerData.match.params.idProduct;

        let upload_data = await api({
            method: 'post',
            url: 'products/'+idProduct+'/set-image',
            formData: true,
            formDataPut: true,
            authorization: this.props.internal.user.access_token,
            params: {
                image: data
            },

        })


        if (upload_data.success && upload_data.success === true) {
            this.setState({message: upload_data.data.message, openSnackbar: true})
            // this.props.internal.photoWasChanged(null)
            return Promise.resolve(false)
        }


    }

    handleChangeSelectedTags = (event) => {
        let selectedTags = this.state.selectedTags
        let allTags = toJS(this.props.internal.dataForSimpeTable.tags_all);

        let number_of_ids = event.target.value.length
        let tmp = event.target.value[number_of_ids-1]


        let tag = allTags.filter(function(tag) {
            if(tag.id === tmp.id) {
                return tag
            }
        })


        let newSelected = []
        let isNotInSelected = true

        for(let i=0; i<selectedTags.length; i++) {
            if(selectedTags[i].id === tag[0].id) {
                isNotInSelected = false
            }
            else {
                newSelected.push(selectedTags[i])
            }
        }

        if(isNotInSelected) {
            newSelected.push(tag[0])
        }

        let selectedIds = []
        newSelected.filter(function(data) {
            selectedIds.push(data.name)
            return null
        })

        this.setState({selectedTags: newSelected, selectedTagsIds: selectedIds}, () => {
            this.updateTags()
        })

    }

    updateTags = async () => {
        let idProduct = toJS(this.props.routerData.match.params.idProduct)

        let arrayIds = []
        this.state.selectedTags.filter(function(tag) {
            arrayIds.push(tag.id)
            return null
        })

        let update_data = await api({
            method: 'patch',
            url: `products/${idProduct}/pair-tags`,
            authorization: this.props.internal.user.access_token,
            params: {
                ids: arrayIds
            }
        })

        if(update_data.success === true) {
            this.setState({message: update_data.data.message, openSnackbar: true})
        } else {
            this.setState({message: update_data.data.message, openSnackbar: true, snackBarError: true})
        }

        // this.loadTags()
        this.loadBasicData(false)
        this.turnOffSnackBar();
    }

    handleChooseCategory = () => {
        this.setState({openCategoryDialog: !this.state.openCategoryDialog})
    }

    getStyles(id, that) {
        return {
            fontWeight:
                that.state.selectedTagsIds.indexOf(id) === -1
                    ? 400
                    : 500,
            backgroundColor:
                that.state.selectedTagsIds.indexOf(id) === -1
                ? 'inherit'
                : 'rgba(0,0,0,0.13)'
        };
    }

    handleDeleteTag = async(id) => {
        this.setState({loading: true})
        let idProduct = toJS(this.props.routerData.match.params.idProduct)
        let selectedTags = this.state.selectedTags

        let newSelectedTagsIds = []
        let newSelectedTags = []
        selectedTags.filter(
            function(data) {
                if(data.id !== id) {
                    newSelectedTagsIds.push(data.id)
                    newSelectedTags.push(data)
                }
                return null
            }
        );

        let update_data = await api({
            method: 'patch',
            url: `products/${idProduct}/pair-tags`,
            authorization: this.props.internal.user.access_token,
            params: {
                ids: newSelectedTagsIds
            }
        })

        if(update_data.success === true) {
            this.setState({message: update_data.data.message, openSnackbar: true, selectedTagsIds: newSelectedTagsIds, selectedTags:newSelectedTags})
        } else {
            this.setState({message: update_data.data.message, openSnackbar: true, snackBarError: true })
        }
        this.turnOffSnackBar()
        this.setState({loading: false})
    }

    addAlternativeProduct = (product) => {
        let ids = product.map(item => item.value)
        this.setState({alternativeProducts: product})
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
            this.updateAlternativeProducts(ids);
        }, TIMEOUT_FOR_API_CALL)
    }

    updateAlternativeProducts = async(ids) => {
        let idProduct = toJS(this.props.routerData.match.params.idProduct)
        //products/:id/pair-alternatives
        let update_data = await api({
            method: 'put',
            url: `products/${idProduct}/pair-alternatives`,
            authorization: this.props.internal.user.access_token,
            params: {
                ids: ids
            }
        })

        if(update_data.success === true) {
            this.props.internal.setSnackbar(update_data.data.message, true)
        }
        else {
            this.props.internal.setSnackbar(update_data.data.message, true)
        }
    }

    timeout = null
    addRelativeProduct = (product) => {
        this.setState({relativeProducts: product})
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
            this.updateRelativeProducts();
        }, TIMEOUT_FOR_API_CALL)
    }
    addRelativeStaticSet = (staticSets) => {
        this.setState({relativeStaticSets: staticSets})
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
            this.updateRelativeProducts();
        }, TIMEOUT_FOR_API_CALL)
    }

    updateRelativeProducts = async(ids) => {
        let idProduct = toJS(this.props.routerData.match.params.idProduct)
        //products/:id/pair-alternatives
        let update_data = await api({
            method: 'put',
            url: `products/${idProduct}/pair-relatives`,
            authorization: this.props.internal.user.access_token,
            params: {
                pids: this.state.relativeProducts.map(i => i.value),
                sids: this.state.relativeStaticSets.map(i => i.value),
            }
        })

        if(update_data.success === true) {
            this.props.internal.setSnackbar(update_data.data.message, true)
        }
        else {
            this.props.internal.setSnackbar(update_data.data.message, true, true)
        }
    }

    addAccessories = async(accessories) => {
        //TODO: dorobit pre prislusenstvo
        this.setState({accessories: accessories})
        let ids = accessories.map(item => item.value)
        let idProduct = toJS(this.props.routerData.match.params.idProduct)
        let update_data = await api({
            method: 'put',
            url: `products/${idProduct}/pair-accessories`,
            authorization: this.props.internal.user.access_token,
            params: {
                ids: ids
            }
        })

        if(update_data.success === true) {
            this.props.internal.setSnackbar(update_data.data.message, true)
        }
        else {
            this.props.internal.setSnackbar(update_data.data.message, true)
        }
    }

    handleChangeProductStatus = async(status) => {
        this.setState({warehouse_status: status.target.value})
        let idProduct = toJS(this.props.routerData.match.params.idProduct)

        let update_data = await api({
            method: 'patch',
            url: `products/${idProduct}`,
            authorization: this.props.internal.user.access_token,
            params: {
                warehouse_status_id: status.target.value
            }
        })

        if(update_data.success) {
            this.props.internal.setSnackbar(update_data.data.message, true)
        }
        else {
            this.props.internal.setSnackbar(update_data.data.message, true)
        }
    }



    timeout2 = null
    handleScrollDown = () => {
        clearTimeout(this.timeout2)
        this.timeout2 = setTimeout(() => {
            let paper = document.getElementById('basicInfo')
            // paper.scrollTop = paper.scrollHeight
            paper.scroll( {
                top: paper.scrollHeight,
                left: 0,
                behavior: 'smooth'
            })
        }, 100)
    }

    handleChage = (field, val) => {
        clearTimeout(this.timeout2)
        this.timeout2 = setTimeout(() => {
            this.updatePageTitle()
        }, TIMEOUT_FOR_API_CALL)
    }

    handleNameChange = (field, val) => {
        clearTimeout(this.timeout2)
        this.timeout2 = setTimeout((val) => {
            this.updateProductName(val)
        }, TIMEOUT_FOR_API_CALL, val)
    }

    updatePageTitle = async() => {
        let idProduct = toJS(this.props.routerData.match.params.idProduct)

        let update_data = await api({
            method: 'patch',
            url: `products/${idProduct}`,
            authorization: this.props.internal.user.access_token,
            params: {
                page_title: this.page_title.state.value
            }
        })

        if(update_data.success) {
            this.props.internal.setSnackbar(update_data.data.message, true)
        }
        else {
            this.props.internal.setSnackbar(update_data.data.message, true)
        }
    }

    updateProductName = async(val) => {
        let idProduct = toJS(this.props.routerData.match.params.idProduct)

        let update_data = await api({
            method: 'patch',
            url: `products/${idProduct}`,
            authorization: this.props.internal.user.access_token,
            params: {
                name: val
            }
        })

        if(update_data.success) {
            this.props.internal.setSnackbar(update_data.data.message, true)
        }
        else {
            this.props.internal.setSnackbar(update_data.data.message, true)
        }
    }

    render() {
        const permissions = toJS(this.props.internal.user.data.permissions.products)

        return(
            this.state.loading && this.state.selectedTags
                ?
                <CircularProgress className = {'circular-progress'}/>
                :
                <div className={'basic-info-container'}>
            <Paper className={'basic-info '} id="basicInfo">
            <CustomSnackbar message={this.state.message} open={this.state.openSnackbar} error={this.state.snackBarError} />
            {this.state.openCategoryDialog ?
                <ChooseCategory
                    open={this.state.openCategoryDialog}
                    onClose={this.handleChooseCategory}
                    title={this.props.translate.i18n.MODULES.PRODUCTS.CHOOSE_CATEGORY_DIALOG_TITLE}
                    routerData={this.props.routerData}
                    dialogType={this.state.dialogType}
                    categories={this.categories}
                    categoriesList={this.categories2}
                    setCategory={this.handleChangeCategory2}
                    idCategory={toJS(this.props.internal.dataForSimpeTable.category) && toJS(this.props.internal.dataForSimpeTable.category.id) ? toJS(this.props.internal.dataForSimpeTable.category.id): ""}
                />
                :
                null
            }
                <div className={'product-image'}>
                    <CustomAvatar
                        src={this.props.internal.dataForSimpeTable.asset_image ? this.props.internal.dataForSimpeTable.asset_image : ""}
                        actionUploadPhoto={this.handleChangePhoto}
                        disableEdit={false}
                    />
                </div>
                <div className={'product-details'}>
                    <TextField
                        disabled
                        label={this.props.translate.i18n.MODULES.PRODUCTS.CODE}
                        id="code"
                        defaultValue={this.props.internal.dataForSimpeTable.code}
                        className={'info-field'}

                        InputProps={{
                            disableUnderline: false,
                            disabled: true,
                            classes:{
                                underline: "disabledUnderline",
                            }
                        }}
                    />
                    <TextField
                        label={this.props.translate.i18n.MODULES.PRODUCTS.NAME}
                        id="name"
                        defaultValue={this.props.internal.dataForSimpeTable.name}
                        className={'info-field'}
                        onChange={(event) => this.handleNameChange('name', event.target.value)}
                    />
                    <CustomInput
                        ref={ref => (this.page_title = ref)}
                        text={this.props.translate.i18n.MODULES.PRODUCTS.PAGE_TITLE}
                        value={this.props.internal.dataForSimpeTable.page_title}
                        id={'page_title'}
                        className={'info-field pageTitle'}
                        change={(val) => this.handleChage('page_title', val)}
                    />
                    <div onClick={permissions.pair_categories ? this.handleChooseCategory : () => {}} className={`info-field choose-category ${permissions.pair_categories ? '' : 'disabled'}`}>
                        <span>{this.props.translate.i18n.MODULES.PRODUCTS.CATEGORY}</span>
                        <p>{this.props.internal.dataForSimpeTable.category && this.props.internal.dataForSimpeTable.category.name ? this.props.internal.dataForSimpeTable.category.name : ""}</p>
                        <Icon path={mdiMenuDown} size={1} className={'mdiMenuDown'}/>
                    </div>
                    <div className={'tags-products'}>
                        <InputLabel htmlFor="select-multiple-chip" className={'choose-tags-label'}>{this.props.translate.i18n.MODULES.PRODUCTS.TAG}</InputLabel>
                        <Select
                            multiple
                            value={this.state.selectedTagsIds }
                            onChange={this.handleChangeSelectedTags}
                            input={<Input id="select-multiple-chip" />}
                            disabled={!permissions.pair_tags}
                            classes={{
                                select: "multiSelect"
                            }}
                            renderValue={selected => (
                                <div>
                                    {this.state.selectedTags.map(value => (
                                    <Chip key={value.id} label={value.name} style={{backgroundColor: value.color, color:"white", height: "25px", margin:"3px 3px 0 0"}} onDelete={() => this.handleDeleteTag(value.id)}/>
                                    ))}
                                </div>
                                )}
                            >
                                {toJS(this.props.internal.dataForSimpeTable.tags_all) ? toJS(this.props.internal.dataForSimpeTable.tags_all).map((tag, index  )=> {
                                    return (
                                        <MenuItem key={tag.id} value={tag} style={this.getStyles(tag.name, this)}>
                                            {tag.name}
                                        </MenuItem>
                                    )
                                })
                                : null
                                }

                            </Select>
                        </div>
                    {/* <TextField
                        id="tag"
                        select
                        label={this.props.translate.i18n.MODULES.PRODUCTS.TAG}
                        className={'info-field'}
                        value={this.state.tag}
                        onChange={this.handleChangeTag}
                        SelectProps={{
                            native: true,
                        }}
                    >
                        {this.props.internal.dataForSimpeTable.tags ? this.props.internal.dataForSimpeTable.tags.map((tag, index) => {
                            return <option key={tag.id} value={tag.id}>{tag.name}</option>
                            //<option key={tag.id} value={tag.id}>{tag.name}</option>
                        })
                        :null
                        }
                    </TextField> */}
                    <TextField
                        disabled
                        label={this.props.translate.i18n.MODULES.PRODUCTS.WAREHOUSE_STATUS}
                        id="warehouse-status"
                        defaultValue={toJS(this.props.internal.dataForSimpeTable.warehouse_info)}
                        className={'info-field'}
                        InputProps={{
                            disableUnderline: false,
                            disabled: true,
                            classes:{
                                underline: "disabledUnderline",
                            }
                        }}
                    />
                    <TextField
                        id="status"
                        select
                        label={this.props.translate.i18n.MODULES.PRODUCTS.WAREHOUSE_STATUS_TITLE_OUT_OF_STOCK}
                        className={'info-field'}
                        value={this.state.warehouse_status}
                        onChange={this.handleChangeProductStatus}
                        InputProps={{
                            disableUnderline: false,
                            classes:{
                                underline: "disabledUnderline",
                            }
                        }}
                    >
                        <MenuItem value={1}>{this.props.translate.i18n.MODULES.PRODUCTS.EDIT_UNAVAILABLE}</MenuItem>
                        <MenuItem value={2}>{this.props.translate.i18n.MODULES.PRODUCTS.EDIT_TO_ORDER}</MenuItem>
                    </TextField>

                    <TextField
                        id="production"
                        select
                        label={this.props.translate.i18n.MODULES.PRODUCTS.PRODUCTION}
                        className={'info-field'}
                        value={this.state.production}
                        onChange={this.handleChangeProduction}
                        disabled={!permissions.change_production}
                        // SelectProps={{
                        //     native: true,
                        // }}
                    >
                        <MenuItem value={true}>{this.props.translate.i18n.GLOBAL.BUTTONS.YES}</MenuItem>
                        <MenuItem value={false}>{this.props.translate.i18n.GLOBAL.BUTTONS.NO}</MenuItem>
                    </TextField>
                    <TextField
                        disabled
                        label={this.props.translate.i18n.MODULES.PRODUCTS.LAST_IMPORT}
                        id="last-import"
                        defaultValue={this.formatData(toJS(this.props.internal.dataForSimpeTable.import))}
                        className={'info-field'}
                        InputProps={{
                            disableUnderline: false,
                            disabled: true,
                            classes:{
                                underline: "disabledUnderline",
                            }
                        }}
                    />
                    <TextField
                        id="shops-production"
                        select
                        label={this.props.translate.i18n.MODULES.PRODUCTS.SHOPS_PRODUCTION}
                        className={'info-field'}
                        value={this.state.shops_production}
                        disabled={!permissions.change_production}
                        onChange={this.handleChangeShopsProduction}
                        // SelectProps={{
                        //     native: true,
                        // }}
                    >
                        <MenuItem value={true}>{this.props.translate.i18n.GLOBAL.BUTTONS.YES}</MenuItem>
                        <MenuItem value={false}>{this.props.translate.i18n.GLOBAL.BUTTONS.NO}</MenuItem>
                    </TextField>
                    <div className={'alternative-relevant'}>
                        <TextField
                            disabled
                            label={this.props.translate.i18n.MODULES.PRODUCTS.UPDATE_AT}
                            id="update-at"
                            defaultValue={this.formatData(toJS(this.props.internal.dataForSimpeTable.updated_at))}
                            className={'info-field'}
                            InputProps={{
                                disableUnderline: false,
                                disabled: true,
                                classes:{
                                    underline: "disabledUnderline",
                                }
                            }}
                        />
                        <SelectSearch
                          options={this.state.clientList}
                          onChange={val => this.changeInvisibleForClients(val)}
                          value={this.state.invisibleForClients}
                          isMulti={true}
                          className={'select-search'}
                          label={this.props.translate.i18n.MODULES.PRODUCTS.INVISIBLE_FOR_CLIENTS}
                          // menuIsOpen
                          onMenuOpen={this.handleScrollDown}
                        />
                    </div>
                    {/* <CustomInput
                        ref={ref => (this.page_title = ref)}
                        text={this.props.translate.i18n.MODULES.PRODUCTS.PAGE_TITLE}
                        value={this.props.internal.dataForSimpeTable.page_title}
                        id={'page_title'}
                        className={'info-field'}
                        change={(val) => this.handleChage('page_title', val)}
                    /> */}
                    <div className={'alternative-relevant'}>
                        <SelectSearch
                            options={this.state.allAlternativeProducts}
                            // key={`param-${i}`}
                            onChange={val => this.addAlternativeProduct(val)}
                            value={this.state.alternativeProducts}
                            isMulti={true}
                            className={'select-search'}
                            label={this.props.translate.i18n.MODULES.PRODUCTS.ALTERNATIVE_PRODUCTS}
                            // menuIsOpen
                            onMenuOpen={this.handleScrollDown}
                        />
                        <SelectSearch
                            options={this.state.allProducts}
                            // key={`param-${i}`}
                            onChange={val => this.addRelativeProduct(val)}
                            value={this.state.relativeProducts}
                            isMulti={true}
                            className={'select-search'}
                            label={this.props.translate.i18n.MODULES.PRODUCTS.RELEVANT_PRODUCTS}
                            // menuIsOpen
                            onMenuOpen={this.handleScrollDown}
                        />
                    </div>
                    <div className={'alternative-relevant'}>
                        <SelectSearch
                          options={this.state.allStaticSets}
                          // key={`param-${i}`}
                          onChange={val => this.addRelativeStaticSet(val)}
                          value={this.state.relativeStaticSets}
                          isMulti={true}
                          className={'select-search'}
                          label={this.props.translate.i18n.MODULES.PRODUCTS.RELATIVE_STATIC_SETS}
                          // menuIsOpen
                          onMenuOpen={this.handleScrollDown}
                        />
                        <SelectSearch
                            options={this.state.allProducts}
                            // key={`param-${i}`}
                            onChange={val => this.addAccessories(val)}
                            value={this.state.accessories}
                            isMulti={true}
                            className={'select-search'}
                            label={this.props.translate.i18n.MODULES.PRODUCTS.ACCESSORIES}
                            // menuIsOpen
                            onMenuOpen={this.handleScrollDown}
                        />
                    </div>
                </div>
            </Paper>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/products/edit/basic/index.js